module.exports = __webpack_public_path__ + "img/logo5.667ea8ca.png";